module.exports = __webpack_public_path__ + "img/pc_p3_x2.f332ff43.svg";